import { useRef } from 'react';
import useMount from '../useMount/index.js';

var useMountRef = function useMountRef() {
  var mountRef = useRef(true);
  useMount(function () {
    return function () {
      return mountRef.current = false;
    };
  });
  return mountRef;
};

export { useMountRef as default };
//# sourceMappingURL=index.js.map
